export const MAX_FEEDBACK_INSTRUCTION_WORDS = 1000;

const WORD_SEPARATORS = /[\s\-–—]+/;

export function countFeedbackInstructionWords(text: string): number {
  if (typeof text !== "string") return 0;
  const trimmed = text.trim();
  if (trimmed.length === 0) return 0;
  return trimmed.split(WORD_SEPARATORS).filter(Boolean).length;
}
